(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["estimated-delivery"] && !Shopify.designMode) return;
  try {
    function estimatedDeliveryAddDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function estimatedDeliveryPushOffSunday(date) {
    const result = new Date(date);
    if (result.getDay() === 0) result.setDate(result.getDate() + 1);
    return result;
  }

  function estimatedDeliveryFormatDate(date) {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function initEstimatedDelivery(root) {
    const shipByDays = parseInt(root.dataset.shipByDays, 10) || 0;
    const skipSunday = root.dataset.skipSunday === 'true';
    const deliveryMinDays = parseInt(root.dataset.deliveryMinDays, 10) || 0;
    const deliveryMaxDays = parseInt(root.dataset.deliveryMaxDays, 10) || 0;

    const ordered = new Date();
    let shipBy = estimatedDeliveryAddDays(ordered, shipByDays);
    if (skipSunday) shipBy = estimatedDeliveryPushOffSunday(shipBy);

    const deliverMin = estimatedDeliveryAddDays(shipBy, deliveryMinDays);
    const deliverMax = estimatedDeliveryAddDays(shipBy, deliveryMaxDays);

    const orderedEl = root.querySelector('[data-estimated-delivery-ordered]');
    const processingEl = root.querySelector('[data-estimated-delivery-processing]');
    const deliveredEl = root.querySelector('[data-estimated-delivery-delivered]');

    if (orderedEl) orderedEl.textContent = estimatedDeliveryFormatDate(ordered);
    if (processingEl) processingEl.textContent = estimatedDeliveryFormatDate(shipBy);
    if (deliveredEl) {
      deliveredEl.textContent = `${estimatedDeliveryFormatDate(deliverMin)} - ${estimatedDeliveryFormatDate(deliverMax)}`;
    }
  }

  document.querySelectorAll('[data-estimated-delivery]').forEach(initEstimatedDelivery);

  // Re-initialize when the theme editor adds/updates this block, so a
  // freshly-dropped block shows real dates without a full page reload.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-estimated-delivery]').forEach(initEstimatedDelivery);
  });
  } catch(e) { console.error(e); }
})();

})();
